export enum KenticoClassName{
    Product = "PPGStainSelector.Product",
    ResultPage="PPGStainSelector.ProductPage",
    Question="PPGStainSelector.Question",
    Answer="PPGStainSelector.Answer",
    AnswerConfimration = "PPGStainSelector.AnswerConfirmation",
    Visualizer = "PPGStainSelector.Visualizer"
}


// WEBPACK FOOTER //
// ./src/app/models/kentico-class-name.enum.ts